/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

/** Can be used to filter products of the shop for an appearance */
export type AppearanceFilter = {
  __typename?: 'AppearanceFilter';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Cart = {
  __typename?: 'Cart';
  checkoutLink?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Currency>;
  id?: Maybe<Scalars['ID']['output']>;
  items?: Maybe<Array<Maybe<CartLineItem>>>;
  lastModified?: Maybe<Scalars['String']['output']>;
  price?: Maybe<CartPrice>;
};

export type CartInput = {
  items?: InputMaybe<Array<InputMaybe<CartLineItemInput>>>;
  promotions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type CartLineItem = {
  __typename?: 'CartLineItem';
  id?: Maybe<Scalars['ID']['output']>;
  product?: Maybe<Product>;
  productVariant?: Maybe<ProductVariant>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type CartLineItemInput = {
  quantity?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['ID']['input']>;
};

export type CartLineItemUpdate = {
  itemId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type CartPrice = {
  __typename?: 'CartPrice';
  discount?: Maybe<Price>;
  original?: Maybe<Price>;
  total?: Maybe<Price>;
};

/** Can be used to filter products of the shop for a category */
export type CategoryFilter = {
  __typename?: 'CategoryFilter';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subCategories?: Maybe<Array<Maybe<Filter>>>;
};

export enum ColorKey {
  /** Navigation (header and footer) background */
  ColorMain_1 = 'COLOR_MAIN_1',
  /** Background for button and cta (primary) */
  ColorMain_2 = 'COLOR_MAIN_2',
  /** Shop background */
  ColorMain_3 = 'COLOR_MAIN_3',
  /** Background for secondary buttons and text color */
  ColorSub_2 = 'COLOR_SUB_2',
  /** Navigation text */
  ColorSub_3 = 'COLOR_SUB_3',
  CustomColorMain_1 = 'CUSTOM_COLOR_MAIN_1',
  CustomColorMain_2 = 'CUSTOM_COLOR_MAIN_2',
  CustomColorMain_3 = 'CUSTOM_COLOR_MAIN_3',
  CustomColorSub_2 = 'CUSTOM_COLOR_SUB_2',
  CustomColorSub_3 = 'CUSTOM_COLOR_SUB_3',
  /** Background color for products */
  ProductBackground = 'PRODUCT_BACKGROUND'
}

export type Currency = {
  __typename?: 'Currency';
  pattern?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
};

export enum Customization {
  Customcss = 'CUSTOMCSS',
  Footerhtml = 'FOOTERHTML',
  Headerhtml = 'HEADERHTML'
}

export type Design = {
  __typename?: 'Design';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  image?: Maybe<Image>;
  name?: Maybe<Scalars['String']['output']>;
};


export type DesignImageArgs = {
  format?: InputMaybe<ImageFormat>;
};

export type DesignFilterInput = {
  appearanceId?: InputMaybe<Scalars['ID']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sizeId?: InputMaybe<Scalars['ID']['input']>;
};

export type DesignSortInput = {
  sortBy?: InputMaybe<SortByEnum>;
  sortOrder?: InputMaybe<SortOrderEnum>;
};

export type DesignsPage = {
  __typename?: 'DesignsPage';
  items?: Maybe<Array<Maybe<Design>>>;
  pageInfo?: Maybe<PageInfo>;
};

/** Can be used to filter products of the shop */
export type Filter = {
  __typename?: 'Filter';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FilterOptions = {
  __typename?: 'FilterOptions';
  appearances?: Maybe<Array<Maybe<AppearanceFilter>>>;
  categories?: Maybe<Array<Maybe<CategoryFilter>>>;
  collections?: Maybe<Array<Maybe<Filter>>>;
  sizes?: Maybe<Array<Maybe<Filter>>>;
};

export enum FontKey {
  Headline = 'HEADLINE',
  Text = 'TEXT'
}

export enum FontType {
  AbrilFatface = 'ABRIL_FATFACE',
  Alata = 'ALATA',
  AlfaSlabOne = 'ALFA_SLAB_ONE',
  Anton = 'ANTON',
  BalooBhai = 'BALOO_BHAI',
  Barlow = 'BARLOW',
  BowlbyOneSc = 'BOWLBY_ONE_SC',
  Calistoga = 'CALISTOGA',
  Catamaran = 'CATAMARAN',
  Dosis = 'DOSIS',
  Heebo = 'HEEBO',
  Hind = 'HIND',
  Inconsolata = 'INCONSOLATA',
  IndieFlower = 'INDIE_FLOWER',
  Khula = 'KHULA',
  Lato = 'LATO',
  LibreFranklin = 'LIBRE_FRANKLIN',
  Lobster = 'LOBSTER',
  LobsterTwo = 'LOBSTER_TWO',
  Montserrat = 'MONTSERRAT',
  Muli = 'MULI',
  NotoSans = 'NOTO_SANS',
  Nunito = 'NUNITO',
  NunitoSans = 'NUNITO_SANS',
  OpenSans = 'OPEN_SANS',
  Oswald = 'OSWALD',
  Pacifico = 'PACIFICO',
  PatuaOne = 'PATUA_ONE',
  PermanentMarker = 'PERMANENT_MARKER',
  Poppins = 'POPPINS',
  PtSans = 'PT_SANS',
  PublicSans = 'PUBLIC_SANS',
  Raleway = 'RALEWAY',
  Righteous = 'RIGHTEOUS',
  Roboto = 'ROBOTO',
  Rubik = 'RUBIK',
  SourceSansPro = 'SOURCE_SANS_PRO'
}

export type Image = {
  __typename?: 'Image';
  altText?: Maybe<Scalars['String']['output']>;
  format?: Maybe<ImageFormat>;
  src?: Maybe<Scalars['String']['output']>;
  srcset?: Maybe<Scalars['String']['output']>;
};

export enum ImageFormat {
  Jpg = 'JPG',
  Png = 'PNG'
}

export enum ImageKey {
  FaviconIcon = 'FAVICON_ICON',
  LogoImage = 'LOGO_IMAGE',
  PromoImage = 'PROMO_IMAGE',
  PromoStockImage = 'PROMO_STOCK_IMAGE'
}

export type LanguageType = {
  __typename?: 'LanguageType';
  isoCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Available locales, use this to get the locale specific data */
export enum Locale {
  DaDk = 'da_DK',
  DeAt = 'de_AT',
  DeCh = 'de_CH',
  DeDe = 'de_DE',
  EnAu = 'en_AU',
  EnCa = 'en_CA',
  EnEu = 'en_EU',
  EnGb = 'en_GB',
  EnIe = 'en_IE',
  EnUs = 'en_US',
  EsEs = 'es_ES',
  FiFi = 'fi_FI',
  FrBe = 'fr_BE',
  FrCa = 'fr_CA',
  FrCh = 'fr_CH',
  FrFr = 'fr_FR',
  ItCh = 'it_CH',
  ItIt = 'it_IT',
  NlBe = 'nl_BE',
  NlNl = 'nl_NL',
  NoNo = 'no_NO',
  PlPl = 'pl_PL',
  SvSe = 'sv_SE'
}

export type Mutation = {
  __typename?: 'Mutation';
  addCartItems?: Maybe<Cart>;
  addCartPromotion?: Maybe<Cart>;
  createCart?: Maybe<Cart>;
  deleteCartItems?: Maybe<Cart>;
  updateCartItems?: Maybe<Cart>;
};


export type MutationAddCartItemsArgs = {
  cartId?: InputMaybe<Scalars['ID']['input']>;
  cartItems?: InputMaybe<Array<InputMaybe<CartLineItemInput>>>;
  platform: Platform;
  shopId: Scalars['ID']['input'];
};


export type MutationAddCartPromotionArgs = {
  cartId?: InputMaybe<Scalars['ID']['input']>;
  platform: Platform;
  promotionId?: InputMaybe<Scalars['ID']['input']>;
  shopId: Scalars['ID']['input'];
};


export type MutationCreateCartArgs = {
  cart?: InputMaybe<CartInput>;
  locale: Locale;
  platform: Platform;
  shopId: Scalars['ID']['input'];
};


export type MutationDeleteCartItemsArgs = {
  cartId?: InputMaybe<Scalars['ID']['input']>;
  cartItemIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  platform: Platform;
  shopId: Scalars['ID']['input'];
};


export type MutationUpdateCartItemsArgs = {
  cartId?: InputMaybe<Scalars['ID']['input']>;
  cartItems?: InputMaybe<Array<InputMaybe<CartLineItemUpdate>>>;
  platform: Platform;
  shopId: Scalars['ID']['input'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum Platform {
  Eu = 'EU',
  Na = 'NA'
}

export type Price = {
  __typename?: 'Price';
  currency?: Maybe<Currency>;
  vatAmount?: Maybe<Scalars['Float']['output']>;
  vatExcluded?: Maybe<Scalars['Float']['output']>;
  vatIncluded?: Maybe<Scalars['Float']['output']>;
};

export type Product = {
  __typename?: 'Product';
  deliveryEta?: Maybe<ProductDeliveryEta>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Image of the product, use views and appearance`s id to cycle between them */
  image?: Maybe<Image>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Price>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<ProductType>;
  variants?: Maybe<Array<Maybe<ProductVariant>>>;
  views?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
};


export type ProductImageArgs = {
  format?: InputMaybe<ImageFormat>;
};

export type ProductAppearance = {
  __typename?: 'ProductAppearance';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ProductDeliveryEta = {
  __typename?: 'ProductDeliveryEta';
  earliestDateUTC?: Maybe<Scalars['String']['output']>;
  latestDateUTC?: Maybe<Scalars['String']['output']>;
  maxDays?: Maybe<Scalars['Int']['output']>;
  minDays?: Maybe<Scalars['Int']['output']>;
};

export type ProductFilterInput = {
  appearanceId?: InputMaybe<Scalars['ID']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sizeId?: InputMaybe<Scalars['ID']['input']>;
};

export type ProductSize = {
  __typename?: 'ProductSize';
  group?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  measures?: Maybe<Array<Maybe<ProductSizeMeasureType>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ProductSizeMeasureType = {
  __typename?: 'ProductSizeMeasureType';
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<ProductSizeMeasureValueType>;
};

export type ProductSizeMeasureValueType = {
  __typename?: 'ProductSizeMeasureValueType';
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type ProductSortInput = {
  sortBy?: InputMaybe<SortByEnum>;
  sortOrder?: InputMaybe<SortOrderEnum>;
};

export type ProductType = {
  __typename?: 'ProductType';
  brand?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  sizeFitHint?: Maybe<Scalars['String']['output']>;
};

export type ProductVariant = {
  __typename?: 'ProductVariant';
  appearance?: Maybe<ProductAppearance>;
  size?: Maybe<ProductSize>;
  sku?: Maybe<Scalars['String']['output']>;
  stockQuantity?: Maybe<Scalars['Int']['output']>;
};

export type ProductsPage = {
  __typename?: 'ProductsPage';
  items?: Maybe<Array<Maybe<Product>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type Promotion = {
  __typename?: 'Promotion';
  code?: Maybe<Scalars['String']['output']>;
  discountPercent?: Maybe<Scalars['Int']['output']>;
  freeShipping?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  minBasketItems?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<PromotionType>;
};

export enum PromotionType {
  Regular = 'REGULAR',
  Special = 'SPECIAL',
  Welcome = 'WELCOME'
}

export type PromotionsPage = {
  __typename?: 'PromotionsPage';
  items?: Maybe<Array<Maybe<Promotion>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type Query = {
  __typename?: 'Query';
  cart?: Maybe<Cart>;
  design?: Maybe<Design>;
  designs?: Maybe<DesignsPage>;
  product?: Maybe<Product>;
  products?: Maybe<ProductsPage>;
  shop?: Maybe<Shop>;
};


export type QueryCartArgs = {
  cartId?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Locale>;
  platform: Platform;
};


export type QueryDesignArgs = {
  id: Scalars['ID']['input'];
  locale: Locale;
  platform: Platform;
  shopId: Scalars['ID']['input'];
};


export type QueryDesignsArgs = {
  filter?: InputMaybe<DesignFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: Locale;
  offset?: InputMaybe<Scalars['Int']['input']>;
  platform: Platform;
  shopId: Scalars['ID']['input'];
  sort?: InputMaybe<DesignSortInput>;
};


export type QueryProductArgs = {
  id: Scalars['ID']['input'];
  locale: Locale;
  platform: Platform;
  shopId: Scalars['ID']['input'];
};


export type QueryProductsArgs = {
  filter?: InputMaybe<ProductFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: Locale;
  offset?: InputMaybe<Scalars['Int']['input']>;
  platform: Platform;
  shopId: Scalars['ID']['input'];
  sort?: InputMaybe<ProductSortInput>;
};


export type QueryShopArgs = {
  locale: Locale;
  name: Scalars['String']['input'];
  platform: Platform;
};

/** A Spreadshop */
export type Shop = {
  __typename?: 'Shop';
  activated?: Maybe<Scalars['Boolean']['output']>;
  /** Selected currency of the shop */
  currency?: Maybe<Currency>;
  /** List of the Shop's customizations */
  customizations?: Maybe<Array<Maybe<ShopCustomization>>>;
  description?: Maybe<Scalars['String']['output']>;
  /** Filter options that can be used to filter products of the shop */
  filterOptions?: Maybe<FilterOptions>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Indicates if "All Languages" actived */
  international?: Maybe<Scalars['Boolean']['output']>;
  /** Selected language of the shop */
  language?: Maybe<LanguageType>;
  name?: Maybe<Scalars['String']['output']>;
  /** List of avaiable promotions to your shop */
  promotions?: Maybe<PromotionsPage>;
  shopUrl?: Maybe<Scalars['String']['output']>;
  /** List of the social channel names of the shop */
  socialChannels?: Maybe<Array<Maybe<ShopSocialChannel>>>;
  /** Theme options of the shop */
  theme?: Maybe<ShopTheme>;
};


/** A Spreadshop */
export type ShopPromotionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ShopCustomization = {
  __typename?: 'ShopCustomization';
  key?: Maybe<Customization>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ShopSocialChannel = {
  __typename?: 'ShopSocialChannel';
  key?: Maybe<SocialChannelEnum>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ShopTheme = {
  __typename?: 'ShopTheme';
  colors?: Maybe<Array<Maybe<ThemeColor>>>;
  fonts?: Maybe<Array<Maybe<ThemeFont>>>;
  images?: Maybe<Array<Maybe<ThemeImage>>>;
  searchEnabled?: Maybe<Scalars['Boolean']['output']>;
  template?: Maybe<Template>;
};

export enum SocialChannelEnum {
  Applemusic = 'APPLEMUSIC',
  Bandcamp = 'BANDCAMP',
  Behance = 'BEHANCE',
  Blogger = 'BLOGGER',
  Blogspot = 'BLOGSPOT',
  Deviantart = 'DEVIANTART',
  DiscordServer = 'DISCORD_SERVER',
  Facebook = 'FACEBOOK',
  Instagram = 'INSTAGRAM',
  Mixcload = 'MIXCLOAD',
  Mixcloud = 'MIXCLOUD',
  Pinterest = 'PINTEREST',
  Snapchat = 'SNAPCHAT',
  Soundcloud = 'SOUNDCLOUD',
  SpotifyArtist = 'SPOTIFY_ARTIST',
  SpotifyShow = 'SPOTIFY_SHOW',
  SpotifyUser = 'SPOTIFY_USER',
  Steam = 'STEAM',
  Tiktok = 'TIKTOK',
  Twitch = 'TWITCH',
  Twitter = 'TWITTER',
  Vimeo = 'VIMEO',
  Website = 'WEBSITE',
  YoutubeChannel = 'YOUTUBE_CHANNEL',
  YoutubeUser = 'YOUTUBE_USER'
}

export enum SortByEnum {
  Created = 'CREATED',
  Featured = 'FEATURED',
  Name = 'NAME'
}

export enum SortOrderEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** The selected template of the shop */
export enum Template {
  Brand = 'BRAND',
  Business = 'BUSINESS',
  Classic = 'CLASSIC',
  Hobby = 'HOBBY',
  Portfolio = 'PORTFOLIO',
  Showcase = 'SHOWCASE'
}

export type ThemeColor = {
  __typename?: 'ThemeColor';
  key?: Maybe<ColorKey>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ThemeFont = {
  __typename?: 'ThemeFont';
  key?: Maybe<FontKey>;
  value?: Maybe<FontType>;
};

export type ThemeImage = {
  __typename?: 'ThemeImage';
  key?: Maybe<ImageKey>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ProductQueryVariables = Exact<{
  platform: Platform;
  shopId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
  locale: Locale;
}>;


export type ProductQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id?: string | null, name?: string | null, description?: string | null, tags?: Array<string | null> | null, views?: Array<string | null> | null, image?: { __typename?: 'Image', src?: string | null, srcset?: string | null, altText?: string | null, format?: ImageFormat | null } | null, price?: { __typename?: 'Price', vatExcluded?: number | null, vatIncluded?: number | null, vatAmount?: number | null, currency?: { __typename?: 'Currency', pattern?: string | null, symbol?: string | null } | null } | null, type?: { __typename?: 'ProductType', id?: string | null, name?: string | null, brand?: string | null, description?: string | null, shortDescription?: string | null, sizeFitHint?: string | null } | null, deliveryEta?: { __typename?: 'ProductDeliveryEta', minDays?: number | null, maxDays?: number | null, earliestDateUTC?: string | null, latestDateUTC?: string | null } | null, variants?: Array<{ __typename?: 'ProductVariant', sku?: string | null, stockQuantity?: number | null, appearance?: { __typename?: 'ProductAppearance', id?: string | null, name?: string | null, values?: Array<string | null> | null } | null, size?: { __typename?: 'ProductSize', id?: string | null, name?: string | null, group?: string | null, measures?: Array<{ __typename?: 'ProductSizeMeasureType', name?: string | null, value?: { __typename?: 'ProductSizeMeasureValueType', value?: number | null, unit?: string | null } | null } | null> | null } | null } | null> | null } | null };

export type ProductFilterQueryVariables = Exact<{
  platform: Platform;
  shopName: Scalars['String']['input'];
  locale: Locale;
}>;


export type ProductFilterQuery = { __typename?: 'Query', shop?: { __typename?: 'Shop', filterOptions?: { __typename?: 'FilterOptions', categories?: Array<{ __typename?: 'CategoryFilter', id?: string | null, name?: string | null, subCategories?: Array<{ __typename?: 'Filter', id?: string | null, name?: string | null } | null> | null } | null> | null, sizes?: Array<{ __typename?: 'Filter', id?: string | null, name?: string | null } | null> | null, appearances?: Array<{ __typename?: 'AppearanceFilter', id?: string | null, name?: string | null, value?: string | null } | null> | null } | null } | null };

export type ProductsQueryVariables = Exact<{
  platform: Platform;
  shopId: Scalars['ID']['input'];
  locale: Locale;
}>;


export type ProductsQuery = { __typename?: 'Query', products?: { __typename?: 'ProductsPage', items?: Array<{ __typename?: 'Product', id?: string | null, name?: string | null, views?: Array<string | null> | null, image?: { __typename?: 'Image', src?: string | null, srcset?: string | null, altText?: string | null, format?: ImageFormat | null } | null, price?: { __typename?: 'Price', vatExcluded?: number | null, vatIncluded?: number | null, vatAmount?: number | null, currency?: { __typename?: 'Currency', pattern?: string | null, symbol?: string | null } | null } | null, type?: { __typename?: 'ProductType', id?: string | null, name?: string | null } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', limit?: number | null, offset?: number | null, totalCount?: number | null } | null } | null };

export type PromotionsQueryVariables = Exact<{
  platform: Platform;
  shopName: Scalars['String']['input'];
  locale: Locale;
}>;


export type PromotionsQuery = { __typename?: 'Query', shop?: { __typename?: 'Shop', promotions?: { __typename?: 'PromotionsPage', items?: Array<{ __typename?: 'Promotion', id?: string | null, minBasketItems?: number | null, discountPercent?: number | null, freeShipping?: boolean | null, code?: string | null, type?: PromotionType | null } | null> | null } | null } | null };

export type ShopQueryVariables = Exact<{
  platform: Platform;
  shopName: Scalars['String']['input'];
  locale: Locale;
}>;


export type ShopQuery = { __typename?: 'Query', shop?: { __typename?: 'Shop', id?: string | null, name?: string | null, currency?: { __typename?: 'Currency', pattern?: string | null, symbol?: string | null } | null, language?: { __typename?: 'LanguageType', name?: string | null, isoCode?: string | null } | null } | null };


export const ProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Product"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Platform"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shopId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Locale"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}},{"kind":"Argument","name":{"kind":"Name","value":"shopId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shopId"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcset"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"format"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vatExcluded"}},{"kind":"Field","name":{"kind":"Name","value":"vatIncluded"}},{"kind":"Field","name":{"kind":"Name","value":"vatAmount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pattern"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"views"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"}},{"kind":"Field","name":{"kind":"Name","value":"sizeFitHint"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryEta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minDays"}},{"kind":"Field","name":{"kind":"Name","value":"maxDays"}},{"kind":"Field","name":{"kind":"Name","value":"earliestDateUTC"}},{"kind":"Field","name":{"kind":"Name","value":"latestDateUTC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sku"}},{"kind":"Field","name":{"kind":"Name","value":"stockQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"appearance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"group"}},{"kind":"Field","name":{"kind":"Name","value":"measures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductQuery, ProductQueryVariables>;
export const ProductFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductFilter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Platform"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shopName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Locale"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shop"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shopName"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filterOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sizes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appearances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductFilterQuery, ProductFilterQueryVariables>;
export const ProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Products"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Platform"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shopId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Locale"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}},{"kind":"Argument","name":{"kind":"Name","value":"shopId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shopId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"srcset"}},{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"format"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vatExcluded"}},{"kind":"Field","name":{"kind":"Name","value":"vatIncluded"}},{"kind":"Field","name":{"kind":"Name","value":"vatAmount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pattern"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"views"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"offset"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<ProductsQuery, ProductsQueryVariables>;
export const PromotionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Promotions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Platform"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shopName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Locale"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shop"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shopName"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promotions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"minBasketItems"}},{"kind":"Field","name":{"kind":"Name","value":"discountPercent"}},{"kind":"Field","name":{"kind":"Name","value":"freeShipping"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PromotionsQuery, PromotionsQueryVariables>;
export const ShopDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Shop"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Platform"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shopName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Locale"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shop"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shopName"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pattern"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isoCode"}}]}}]}}]}}]} as unknown as DocumentNode<ShopQuery, ShopQueryVariables>;